import '~/init'
import '~/controllers'
import '~/turbo-mount'
import TurboPower from "turbo_power";

TurboPower.initialize(Turbo.StreamActions)

// Import JS and CSS from view_components
import.meta.glob('../../components/**/*.js', { eager: true })
import.meta.glob('../../components/**/*.css', { eager: true })
